export default class MessageParserError extends Error {
	column: number;
	expected: string;
	found: string;
	line: number;
	offset: number;

	constructor(message: string, expected: string, found: string, offset: number, line: number, column: number) {
		super(message);

		this.expected = expected;
		this.found = found;
		this.offset = offset;
		this.line = line;
		this.column = column;
	}
}
